import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.4186 2.00012H5.65123C4.40144 1.98765 3.39623 2.95665 3.22282 4.18177L2.0265 12.5536C1.92388 13.2791 2.12147 14.0234 2.5811 14.5905C3.04168 15.1589 3.72447 15.4959 4.45498 15.4885H8.95488V18.5117C8.95488 20.3911 10.3861 22 12.2533 22H12.7195L16.1873 13.6276H18.6966C20.2911 13.6484 21.7511 12.5604 21.9908 11.0987L22 11.0427V4.48292L21.9908 4.42686C21.7446 2.9252 20.2443 1.97997 18.6966 2.00032H16.4186V2.00012ZM4.60444 4.37703C4.69032 3.76935 5.16212 3.38976 5.63918 3.39542L15.0232 3.39547V12.7916L11.8111 20.5466C10.9989 20.3309 10.3502 19.5344 10.3502 18.5117V14.0932L4.45111 14.0931L4.44264 14.0932C4.15757 14.0967 3.8712 13.9663 3.66517 13.712C3.4573 13.4555 3.3582 13.1028 3.4081 12.749L4.60444 4.37703ZM18.7116 3.3956C19.7501 3.38044 20.4721 3.98546 20.6046 4.60402V10.922C20.4656 11.5815 19.7057 12.2467 18.7116 12.2322H16.4186V3.39567L18.7014 3.39575L18.7116 3.3956Z"
      fill="currentColor"
    />
  </svg>
);
